import { graphql } from '../../../graphql/generated';

export const ANALYSIS_STATIONS_QUERY = graphql(`
  query AnalysisStations($labId: ID!) {
    labAnalysisStations(labId: $labId) {
      id
      name
      description
    }
  }
`);
